import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {listCollectionHistory, listClientLocations} from '../../actions/homeActions';
import { BASE_URL } from '../../constants';
import CollectionHistory from './CollectionHistory';
import PortalInformation from './PortalInformation';
import UpcomingRequestsList from './UpcomingRequetsList';
import ClientHomeActionButtons from './ClientHomeActionButtons';
import { push } from '../../utils/navigation';

const ClientHome = ({collectionHistory, account, dispatch, clientLocations = [], userId, clientLocationsDelivery = []}) => {
    const [siteType, setSiteType] = useState("");
    const [upcomingRequestLoading, setUpcomingRequestLoading] = useState(true);

    useEffect(() => {
        getCollectionHistory();
        getUrgentCollections();
        getUrgentDeliveries();
        const currentLocation = window.location && window.location.href;
        if(currentLocation && currentLocation.includes("coastalcookingoils")){
            setSiteType("CCOILS");
        }
        else{
            setSiteType("SRS");
        }
    }, []); 

    const getCollectionHistory = () => {
        dispatch(listCollectionHistory());
    };

    const getUrgentCollections = () => {
      dispatch(listClientLocations('Collection')).then(() => {
        setUpcomingRequestLoading(false);
      });
    };

    const getUrgentDeliveries = () => {
      dispatch(listClientLocations('Fresh Oil')).then(() => {
        setUpcomingRequestLoading(false);
      });
    };

    const handleUpdateDetails = () => {
      dispatch(push(`${BASE_URL}/manage/users/${userId}`));
    };

    return(
        <div>
            <h5 className="mb-2 mt-h flex justify-content-between flex-wrap align-items-center">
              <span>Hi {account && account.user && account.user.name}, Welcome to your {siteType} Client Portal</span> 
              <button className='btn bg-primary' onClick={handleUpdateDetails}>Update Details</button>
            </h5>
            <PortalInformation 
              siteType={siteType}
            />
            <UpcomingRequestsList 
              collectionList={clientLocations}
              deliveryList={clientLocationsDelivery}
              loading={upcomingRequestLoading}
            />
            <ClientHomeActionButtons /> 
            {/* Last 5 collection history */}
            <CollectionHistory 
              collectionHistory={collectionHistory}
            />
        </div>
    );
};

function mapStateToProps(state){
    return {
      account: state.account,
      collectionHistory: state.home && state.home.collectionHistory,
      clientLocations: state.home && state.home.clientLocations,
      userId: state.account && state.account.user && state.account.user.id,
      clientLocationsDelivery: state.home && state.home.clientLocationsDelivery,
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      dispatch
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(ClientHome);